module.exports = "<div seedelement><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-index/theme/lui-index.html
// module id = 225
// module chunks = 0 1 16